import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SmartTableConsumer } from '../smart-table-consumer';
import { SmartTableService } from '../smart-table.service';

@Component({
	selector: 'ws-date-range-filter',
	templateUrl: './date-range-filter.component.html',
	styleUrls: ['./date-range-filter.component.scss'],
})
export class DateRangeFilterComponent extends SmartTableConsumer implements OnInit {
	@Input() field!: string;
	@Input() result!: any;
	@Output() resultChange: EventEmitter<any> = new EventEmitter<any>();

	constructor(smartTableService: SmartTableService) {
		super(smartTableService);
	}

	ngOnInit() {
		this.smartTableService.criteriaCleared$.subscribe(() => {
			this.reset();
		});
	}

	public reset() {
		this.result.from = undefined;
		this.result.to = undefined;
		this.resultChange.emit(this.result);
	}
}
